import { apiErrorStatus } from 'app/services/api/apiErrorStatus';

const REDEEM_OFFER_ERROR_KEYS: Record<string, string> = {
  BADGE_REQUIRED: 'pages.clients.offersDialog.errors.badgeRequired',
  OFFER_USAGE_LIMIT_REACHED: 'pages.clients.offersDialog.errors.usageLimitReached',
};

export const redeemOfferErrorKey = (error: unknown): string =>
  REDEEM_OFFER_ERROR_KEYS[apiErrorStatus(error) ?? ''] ?? 'pages.clients.offersDialog.errors.redeem';
